/*
 * CircuitEdit Messages
 *
 * This contains all the text for the CircuitEdit component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.CircuitEdit.title',
    defaultMessage: 'Edit Circuit',
  },
  saveButton: {
    id: 'app.containers.CircuitEdit.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.CircuitEdit.saveSuccess',
    defaultMessage: 'Circuit has been successfully updated.',
  },
  saveFailure: {
    id: 'app.containers.CircuitEdit.saveFailure',
    defaultMessage: 'Error. The circuit could not be updated.',
  },
});
